import { object, ObjectSchema, string } from 'yup';

import { CultureValue } from '@client/api';

const schema: ObjectSchema<CultureValue> = object({
  language: string().required(),
  timezone: string().required(),
});

export { schema as cultureValueSchema };
